export default "__VITE_ASSET__C81992og__"